module.exports = __webpack_public_path__ + "img/4d2a7cd.png";